import {
  object as yupObject,
} from 'yup';
import merge from 'lodash/merge';

import {
  obligationSchemaShape,
  checkEntityForDuplicate,
} from '../../../administration/obligationsPage/validators';
import { ValidateRowsFn } from '../../../shared/gridEdit/useEditableGridLogic';
import {
  ScenarioObligation,
  ScenariosObligationsListLookupData,
} from '../../../shared/queries/scenarios';
import { validateBaseSchema } from '../../../shared/gridEdit/validators';


const obligationBaseSchema = yupObject().shape({
  companyCode: obligationSchemaShape.companyCode,
  countryCode: obligationSchemaShape.companyCode,
  countryTaxType: obligationSchemaShape.countryTaxType,
  overrideTaxCurrency: obligationSchemaShape.taxCurrency,
  federalFTCLimit: obligationSchemaShape.federalFTCLimit,
  overrideTaxRate: obligationSchemaShape.currentTaxRate,
  overrideDefTaxRate: obligationSchemaShape.deferredTaxRate,
  NOL: obligationSchemaShape.NOL,
  recordVA: obligationSchemaShape.recordVA,
  stateApportionmentRate: obligationSchemaShape.stateApportionmentRate,
  statePrePostNOL: obligationSchemaShape.statePrePostNOL,
  stateMinimumTax: obligationSchemaShape.stateMinimumTax,
});

export const validateScenarioObligation: ValidateRowsFn<ScenarioObligation, ScenariosObligationsListLookupData> = (
  obligation,
  context,
  allObligations
) => {
  const baseSchemaError = validateBaseSchema(obligationBaseSchema, obligation, context);
  const duplicateError = checkEntityForDuplicate(obligation, context, allObligations);

  return {
    errors: merge({}, baseSchemaError, duplicateError),
  };
};
